import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function SharedMediaReducer(state = initialState.sharedMedia, { type, data, xmppId, mediaIds, lastSynchAt }) {
  switch (type) {
    case types.GET_SHARED_MEDIA_REQUEST: {
      return state.set('isLoading', true);
    }
    case types.GET_SHARED_MEDIA_SUCCESS: {
      let _items = [...data.items];
      if (!state.dataByXmppId[xmppId]) {
        const dataByXmppId = { ...state.dataByXmppId };
        dataByXmppId[xmppId] = {
          items: _items,
          hasNextPage: data.hasNextPage,
        };
        return state.set('dataByXmppId', dataByXmppId).set('isLoading', false);
      }
      return state
        .setIn(['dataByXmppId', xmppId], {
          ...state.dataByXmppId[xmppId],
          ...data,
          items: lastSynchAt === 0 ? _items : [...state.dataByXmppId[xmppId].items, ..._items],
        })
        .set('isLoading', false);
    }
    case types.GET_SHARED_MEDIA_FAILED: {
      return state.set('isLoading', false);
    }
    case types.DELETE_SHARED_MEDIA_SUCCESS: {
      const dataByXmppId = { ...state.dataByXmppId };
      dataByXmppId[xmppId] = {
        items: dataByXmppId[xmppId]?.items?.filter(item => !mediaIds.includes(item.id)) || [],
        pageNumber: dataByXmppId[xmppId]?.pageNumber || 1,
        hasNextPage: dataByXmppId[xmppId]?.hasNextPage || false,
      };
      return state.set('dataByXmppId', dataByXmppId);
    }
    default:
      return state;
  }
}
